
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gE59GefLy3KNmfDghhspZG3OXNtgJVDGney51pMr9PFQMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexQDvTJ_45B8z_njQcKt7mJkgpONX4elGV_45hEuK4CszOWXkMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchN9hUa_45PjljSJ_45tV_gyJ8uYrM9cNs_45WY7uQ_45XQ5yT5ugMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexeub9Kgsb7F_Km9bloBYfsAYmnq6Oq2eTQUc5A_WfZcAMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bKZMI8fWThm6jNtBljkIDMIwKdeBxQ6N_DkFwTMbjOUMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexw6rpfanqZ0mkP1p86Jdp8h07SYPqcTCJ5_45tx4bWDckcMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93WUqscJ1ZTDiTTZocRcxmyY3AvLSojuzWmrAzFOH3Ny8Meta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexl9yCMW00bsJNX5BnkLfHWZP2va9Y7G7NgoKCay_45dMp8Meta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_930SgYJRXADHaWbRmLJSrmlu0Mp12K5pdXBYaMHTq2TAoMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexrfkyXE7X6RqAutCtFRXPvgkVcsT1kvkWKuC5LWLHnqQMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexIxsGsYLcPJuipCgAMwTBXD0lCiXw0SI8ClEQAZfhwFkMeta } from "/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexw6rpfanqZ0mkP1p86Jdp8h07SYPqcTCJ5_45tx4bWDckcMeta || {},
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexl9yCMW00bsJNX5BnkLfHWZP2va9Y7G7NgoKCay_45dMp8Meta || {},
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexrfkyXE7X6RqAutCtFRXPvgkVcsT1kvkWKuC5LWLHnqQMeta || {},
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexIxsGsYLcPJuipCgAMwTBXD0lCiXw0SI8ClEQAZfhwFkMeta || {},
    component: () => import("/codebuild/output/src2647325335/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]